import { create } from 'zustand';

export type RpcLatencyInfo = {
	avg: number | null;
	lastFiveLatencies: number[];
};

export type RpcLatencies = Record<string, RpcLatencyInfo>;

interface RpcLatencyStore {
	latencies: RpcLatencies;
	setLatencies: (latencies: RpcLatencies) => void;
}

/**
 * Holds the shared RPC latency measurements. Populated once by
 * `useSyncAllRpcLatencies` (mounted in `useAppSetup`) and read by consumers via
 * `useAllRpcLatencies`. Replaces the previous react-singleton-hook wrapper.
 */
export const useRpcLatencyStore = create<RpcLatencyStore>((set) => ({
	latencies: {},
	setLatencies: (latencies) => set({ latencies }),
}));
